module.exports = __webpack_public_path__ + "static/media/wow.2a8ba99b.jpg";